import React from 'react';

// 🚩 Si Google Maps falla al cargar (red, CORS por restricción de dominio de
// la API key, bloqueo de ads, etc.) esto evita que se caiga TODA la app a una
// pantalla en blanco — sin esto, un error acá revienta el árbol de React
// completo (no hay manejo de errores por defecto en React para esos casos).
class MapaErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { error: null }; }
    static getDerivedStateFromError(error) { return { error }; }
    componentDidCatch(error) { console.error('Error cargando el mapa:', error); }
    render() {
        if (this.state.error) {
            return this.props.fallback || (
                <div className="alert alert-warning text-center small mb-0" style={{ borderRadius: '10px' }}>
                    ⚠️ No se pudo cargar el mapa en este momento.
                </div>
            );
        }
        return this.props.children;
    }
}

export default MapaErrorBoundary;
